import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../../store/AuthContext';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import IconBack from '../../../Icons/IconBack';
import { HostProvider } from '../../../utils/HostProvider';
import DataService from '../../../services/MisDatosService';
import useAPIError from '../../../hooks/useAPIError';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setShowOpinionForm: (opinion: boolean) => void;
  isDigital: boolean;
  isSocioEroski: boolean;
  tipoSocio?: number;
}

const BajaForm: FC<Props> = (props) => {
  const {
    visible,
    setVisible,
    setShowOpinionForm,
    isSocioEroski,
    isDigital,
    tipoSocio,
  } = props;
  const isEroski = HostProvider.isEroski();
  const isCaprabo = HostProvider.isCaprabo();
  const dataUser = useAuthStore();
  const { t } = useTranslation();
  const { addError, addErrorBack } = useAPIError();
  const [serviciosNutricionales, setServiciosNutricionales] = useState<boolean>(
    false,
  );
  const [ticketDigital, setTicketDigital] = useState<boolean>(false);
  const [familiaJoven, setFamiliaJoven] = useState<boolean>(false);
  const [oro, setOro] = useState<boolean>(false);
  const [tarjetaCredito, setTarjetaCredito] = useState<boolean>(false);
  const [algunaVezApp, setAlgunaVezApp] = useState<boolean>(false);
  const [preferenciaCD, setPreferenciaCD] = useState<boolean>(false);
  const [load, setLoad] = useState<boolean>(false);
  const retrieveServiciosSuscritos = (callServSuscritos: boolean) => {
    if (callServSuscritos) {
      DataService.serviciosSuscritos()
        .then((response) => {
          if (response.data.error === true) {
            addErrorBack(response.data);
          } else if (response.data && response.data.pojo) {
            setServiciosNutricionales(
              response.data.pojo.serviciosNutricionales,
            );
            setTicketDigital(response.data.pojo.ticketDigital);
            setFamiliaJoven(response.data.pojo.familiaJoven);
            setOro(response.data.pojo.oro);
            setTarjetaCredito(response.data.pojo.tarjetaCredito);
            setAlgunaVezApp(response.data.pojo.algunaVezAppClub);
            setPreferenciaCD(response.data.pojo.preferenciaCD);
            setLoad(true);
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
    }
  };
  const servicesLost: string[] = [];
  const avisosDigital: string[] = [];
  const txtSpanSocioEroski: string[] = [];
  const txtPSocioEroski: string[] = [];

  function txtEspecificosCaprabo() {
    if (isDigital) {
      servicesLost.push('datos.baja.online-shopping');
      if (!isSocioEroski) {
        avisosDigital.push('caprabo.baja.unsubscribe-digital-body-first-line');
        avisosDigital.push('caprabo.baja.unsubscribe-digital-body-second-line');
      } else {
        avisosDigital.push(
          'caprabo.baja.unsubscribe-eroski-body-third-line-caprabo',
        );
        avisosDigital.push(
          'caprabo.baja.unsubscribe-eroski-body-forth-line-caprabo',
        );
      }
      if (preferenciaCD) {
        servicesLost.push('caprabo.baja.preferenciaClienteDigital');
      }
    } else if (isSocioEroski) {
      txtSpanSocioEroski.push(
        'caprabo.baja.unsubscribe-eroski-body-first-line-caprabo',
      );
      txtPSocioEroski.push(
        'caprabo.baja.unsubscribe-eroski-body-second-line-caprabo',
      );
    }
  }

  function txtEspecificosEroski() {
    if (isDigital) {
      servicesLost.push('datos.baja.online-shopping');
      if (!isSocioEroski) {
        avisosDigital.push('datos.baja.unsubscribe-body-first-line');
        avisosDigital.push('datos.baja.unsubscribe-body-second-line');
      } else {
        txtPSocioEroski.push('datos.baja.unsubscribe-eroski-body-forth-line');
        txtSpanSocioEroski.push(
          'datos.baja.unsubscribe-eroski-body-third-line',
        );
      }
      if (preferenciaCD) {
        servicesLost.push('datos.baja.preferenciaClienteDigital');
      }
      if (algunaVezApp) {
        servicesLost.push('datos.baja.eroski-app');
      }
    }
    if (isSocioEroski) {
      if (!isDigital) {
        txtSpanSocioEroski.push(
          'datos.baja.unsubscribe-eroski-body-first-line',
        );
        txtPSocioEroski.push('datos.baja.unsubscribe-eroski-body-second-line');
      }
      if (oro) {
        servicesLost.push('datos.baja.gold-card');
      }
      if (tarjetaCredito) {
        servicesLost.push('datos.baja.credit-card');
      }
      if (familiaJoven) {
        servicesLost.push('datos.baja.family-plan');
      }
      if (serviciosNutricionales) {
        servicesLost.push('datos.baja.nutri-services');
      }
    }
  }

  if (isEroski) {
    txtEspecificosEroski();
  } else if (isCaprabo) {
    txtEspecificosCaprabo();
  }
  if (ticketDigital) {
    servicesLost.push('datos.baja.digital-ticket');
  }

  useEffect(() => {
    if (dataUser.user.token !== '') setLoad(true);
  }, [dataUser.user.token]);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.querySelector(
        'section.o-section--large.form-baja.bloque-form.visible',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('baja-continue-btn').click();
    }
  };

  useEffect(() => {
    const element = document.querySelector(
      'section.o-section--large.form-baja.bloque-form.visible',
    ) as HTMLElement;
    if (visible && load) {
      retrieveServiciosSuscritos(true);
      element.setAttribute('tabindex', '0');
      element.focus();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      element.addEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <section
                className={`o-section--large form-baja bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a
                    id="baja-back"
                    href="#baja"
                    className="link-prev"
                    onClick={() => {
                      setVisible(false);
                      document.body.classList.remove('fix');
                    }}
                  >
                    <div className="icon icon-medium">
                      <IconBack />
                    </div>
                    <p className="u-font-normal u-text-brand u-margin-left">
                      {t('datos.baja.back')}
                    </p>
                  </a>
                  <h2 className="bloque-datos__title u-text-brand">
                    <span className="divider__square brand-color" />
                    <span className="u-margin-right">
                      {t('datos.baja.request-unsubscribe')}
                    </span>
                  </h2>

                  {avisosDigital.map((avisoDigital) => (
                    <>
                      <p>{t(avisoDigital)}</p>
                    </>
                  ))}

                  {isSocioEroski ? (
                    <>
                      <p>
                        {txtSpanSocioEroski.map((avisoSpanSocioEroski) => (
                          <span>{t(avisoSpanSocioEroski)}</span>
                        ))}
                        {tipoSocio === MisDatosConstants.TIPO_SOCIO_AMBOS ? (
                          <span> y {t('datos.baja.consumer')}</span>
                        ) : (
                          ''
                        )}
                        .
                      </p>
                      {txtPSocioEroski.map((avisoPSocioEroski) => (
                        <p>{t(avisoPSocioEroski)}</p>
                      ))}
                    </>
                  ) : (
                    ''
                  )}

                  <ul className="lista-requisitos u-margin-top">
                    <>
                      {servicesLost.map((servicioPerdido) => (
                        <li>{t(servicioPerdido)}</li>
                      ))}
                    </>
                  </ul>

                  {isDigital && !isSocioEroski && (
                    <p className="u-margin-top">
                      {t('datos.baja.vouchers-paper-note')}
                    </p>
                  )}

                  <div className="u-text-right u-margin-top">
                    <a
                      href="#baja"
                      className="btn btn-secundary u-margin-right-large"
                      onClick={() => {
                        setVisible(false);
                        document.body.classList.remove('fix');
                      }}
                    >
                      {t('datos.baja.cancel')}
                    </a>
                    <button
                      id="baja-continue-btn"
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setShowOpinionForm(true);
                      }}
                    >
                      {t('datos.baja.continue')}
                    </button>
                  </div>
                </div>
              </section>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default BajaForm;
